import { render, staticRenderFns } from "./GroundWaterSvg.vue?vue&type=template&id=53a2bef8&"
import script from "./GroundWaterSvg.vue?vue&type=script&lang=js&"
export * from "./GroundWaterSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports